import React from 'react';
import {
    Route,
    Redirect,
} from 'react-router-dom';

function PrivateRoute({ children, userRole, roles, ...rest }) {

    return (
        <Route
            {...rest}
            render={() => {
                if (!roles.length || roles.includes(userRole)) {
                    return children
                } else {
                    return <Redirect to="/" />
                }
            }}
        />
    );
}

export default PrivateRoute